var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_20142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50033 5.41215H2.62533C2.23855 5.41215 1.86762 5.2585 1.59413 4.98501C1.32064 4.71152 1.16699 4.34059 1.16699 3.95382C1.16699 3.56704 1.32064 3.19611 1.59413 2.92262C1.86762 2.64913 2.23855 2.49548 2.62533 2.49548H3.50033",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.41215H11.375C11.7618 5.41215 12.1327 5.2585 12.4062 4.98501C12.6797 4.71152 12.8333 4.34059 12.8333 3.95382C12.8333 3.56704 12.6797 3.19611 12.4062 2.92262C12.1327 2.64913 11.7618 2.49548 11.375 2.49548H10.5",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 12.9955H11.6663",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 8.71375V10.0787C5.83301 10.3996 5.55884 10.6504 5.26717 10.7846C4.57884 11.0996 4.08301 11.9687 4.08301 12.9954",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 8.71375V10.0787C8.16699 10.3996 8.44116 10.6504 8.73283 10.7846C9.42116 11.0996 9.91699 11.9687 9.91699 12.9954",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.32874H3.5V5.41207C3.5 6.34033 3.86875 7.23057 4.52513 7.88694C5.1815 8.54332 6.07174 8.91207 7 8.91207C7.92826 8.91207 8.8185 8.54332 9.47487 7.88694C10.1313 7.23057 10.5 6.34033 10.5 5.41207V1.32874Z",
    stroke: "#8A6CC8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_20142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.162109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.6e6e551474e8c21b9eb815c7f2c9a2b1.svg";
export { ForwardRef as ReactComponent };